import messages from '@intlify/unplugin-vue-i18n/messages';
import { cookies } from 'config';
import Cookies from 'js-cookie';
import { cloneDeepWith, isEmpty } from 'lodash';
import { store as trackingStore } from 'store/tracking';
import { App, watch } from 'vue';
import { createI18n /*, IntlDateTimeFormat */ } from 'vue-i18n';

import store from './store';

// const datetimeFormats:any = {
//   fr: timeFr,
//   en: timeEn,
// }

const i18n = createI18n({
  legacy: false,
  formatFallbackMessages: true,
  silentFallbackWarn: true,
  silentTranslationWarn: true,
  fallbackWarn: false,
  missingWarn: false,
  // useScope: 'global'
  globalInjection: true, // no need of `const {t} = useI18n()`
  // datetimeFormats
  messages
})

/** easier $t that returns anything (for v-for etc) */
export function tr(key:string): any | any[] | {[key:string]:any}{
  //@ts-ignore
  return cloneDeepWith(i18n.global.tm(key) as Obj, (value:string) => {
    if(typeof value === "function") {
      return i18n.global.rt(value);
    }
  });
}

/** override install to add $tr */
export default {
  ...i18n,
  install: (app:App/*, options:unknown[]*/):void => {
    i18n.install(app)
    app.config.globalProperties.$tr = tr
  }
}

export { store };
const state = store.state;

/** always sync messages */
watch(
  () => {
    const {code} = state.locale ?? {code: ''}
    return {
      code,
      loaded: state.loaded[code!],
      messages:state.data.messages[code!]
    }
  },
  ({messages, code}) => {
    if (!code || isEmpty(messages)) return
    if (trackingStore.consents.preferences) {
      Cookies.set(cookies.locale, code);
    }
    i18n.global.setLocaleMessage(code, messages)
  },
  { immediate:true }
)

// watch(
//   () => {
//     const {code} = state.locale ?? {}
//     return {
//       code,
//       formats:state.data.datetimeFormats[code||''] as IntlDateTimeFormat
//     }
//   },
//   ({formats, code}) => {
//     if (!code) return
//     i18n.global.setDateTimeFormat(code, formats)
//   },
//   { immediate:true }
// )

/** always sync locale */
watch(
  ()=> state.locale?.code,
  (code) => {
    if (!code) return
    i18n.global.locale.value = code
  },
  { immediate:true }
)
